import { render, staticRenderFns } from "./WIJDWIKO.vue?vue&type=template&id=3038ff9c&scoped=true&"
import script from "./WIJDWIKO.vue?vue&type=script&lang=js&"
export * from "./WIJDWIKO.vue?vue&type=script&lang=js&"
import style0 from "./WIJDWIKO.vue?vue&type=style&index=0&id=3038ff9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3038ff9c",
  null
  
)

export default component.exports